<template>
  <div>
    <div class="WorkReportBottom-Com">
      <div>
        <div class="UploadReport-Com">
          <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/editor.png')" :title="EditTitle" fontSize="14px" @btnclick="EditHistory">
          </Commonbtn>
          <Commonbtn backgroundColor="#FFF" :src="require('@/assets/channel/Fullscreen.png')" title="全屏填写" fontSize="14px" @btnclick="operationHistory">
          </Commonbtn>
          <CommonbtnUpLoad backgroundColor="#FFF" types="file" title="上传报表" fontSize="14px" @getFile="UploadReport" :src="require('@/assets/channel/DailyWork/icon-rc_upload.png')">
          </CommonbtnUpLoad>
        </div>
        <a class="Dowload" style="" @click="ReportDowload">
          下载报表
        </a>
      </div>

      <div>
        <!-- <div class="NewDateTime-Com">
          报表更新时间：
          <span>
            {{TimeDate}}
          </span>
        </div> -->
        <div class="SubmissionHistory-Com">
          <Commonbtn backgroundColor="#FFF" :src="require('@/assets/channel/DailyWork/icon-rc_tjls.png')" title="提交历史" fontSize="14px" @btnclick="SubmissionHistory">
          </Commonbtn>
        </div>
      </div>
    </div>

    <WorkReportCommonTable ref="WorkRef" :YCXOptionsDisabled="YCXOptionsDisabled" :LNQNKZDGptionsDisabled="LNQNKZDGptionsDisabled" :LNZZDGptionsDisabled="LNZZDGptionsDisabled" :LNZCDGptionsDisabled="LNZCDGptionsDisabled" :YDTLDYGptionsDisabled="YDTLDYGptionsDisabled" :PQDYGptionsDisabled="PQDYGptionsDisabled" :THQOptionsDisabled="THQOptionsDisabled" :QSZJOptionsDisabled="QSZJOptionsDisabled" :DetailRemarkdisabled="DetailRemarkdisabled" :PTAOptionsDisabled="PTAOptionsDisabled" :HPOptionsDisabled="HPOptionsDisabled" :DCBOptionsDisabled="DCBOptionsDisabled" :GCOptionsDisabled="GCOptionsDisabled" :GCBOptionsDisabled="GCBOptionsDisabled" :total="total" :paginationFalg="paginationFalg" :headerData="headerDataWorkReport" :tableData="tableDataWorkReport" @handlePageIndexChange="handlePageIndexChange" @handleSizeChange="handleSizeChange" @onRowClick="onRowClickWorkReport"></WorkReportCommonTable>
    <div class="Btns">
      <Commonbtn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" title="提交报表" color="#FFFFFF" @btnclick="SubmitReport">
      </Commonbtn>
    </div>
    <DialogFrom width="1000px" :OKASCAN="false" title="历史提交报表" :dialogVisible="dialogVisiblesHistory" @cancel="cancelHistory" @dialogOK="dialogOKHistory" :dialogOKFlag="false">
      <div class="from" v-if="!RowFlag">
        <HistoryTable @handlePageIndexChange="handleHistoryPageIndexChange" @handleSizeChange="handleSizeHistoryChange" @onRowClick="onRowClickHistory" @operation="operationHistory" :TableData="tableDataHistory" :total="totalHistory" :headerData="headerDataHistory"></HistoryTable>
      </div>
      <div class="from" v-else>
        <Commonbtn btnType='btn' border="1px solid #E6E8EB" backgroundColor="#FAFBFC" width="80px" height="32px" title="查看全部" fontSize="14px" @btnclick="LookAll">
        </Commonbtn>
        <HistoryTable ref="TableComRef" @handlePageIndexChange="handleHistoryPageIndexChange" @handleSizeChange="handleSizeHistoryChange" @onRowClick="onRowClickHistory" :TableData="tableDataHistory" :headerData="headerDataHistory" :total="totalHistory"></HistoryTable>
      </div>
    </DialogFrom>
    <DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg" @dialogOK="dialogOKdrjg">
      <div class="from" style="">
        <CommonTable width="830px" colnum=100 :tableData="tableDatadrjgs" height="100%">
        </CommonTable>
      </div>
    </DialogFrom>
  </div>
</template>

<script>
import Commonbtn from '../../../../../../components/common-btn.vue'
import CommonTable from '../../../../../../components/common-table.vue'
import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
import WorkReportCommonTable from './components/TableCom'
import DialogFrom from '../../../../../../components/dialog-from.vue'
import HistoryTable from '../components/components/HistoryTable'
import headerDataHistory from '../components/components/FromData/headerDataHistory'
import headerData from '../components/components/FromData/headerData'
import {
  HospitalProcessList,
  HospitalEditProcess,
  HospitalGetProcessOperation,
  HospitalExportProcessList,
  HospitalImportProcess
} from '@/api/channel'
import utils from '../../../../../../common/utils'
export default {
  components: { Commonbtn, CommonTable, CommonbtnUpLoad, WorkReportCommonTable, HistoryTable, DialogFrom },
  props: {

  },
  data() {
    return {
      dialogVisiblesHistory: false,
      paginationFalg: false, //分页组件是否显示
      PTAOptionsDisabled: true, //table表格中的下拉列表是否可用
      HPOptionsDisabled: true,//table表格中的下拉列表是否可用
      DCBOptionsDisabled: true,//table表格中的下拉列表是否可用
      GCBOptionsDisabled: true,//table表格中的下拉列表是否可用
      GCOptionsDisabled: true,
      YCXOptionsDisabled: true,
      QSZJOptionsDisabled: true,
      THQOptionsDisabled: true,
      PQDYGptionsDisabled: true,
      YDTLDYGptionsDisabled: true,
      LNZCDGptionsDisabled: true,
      LNZZDGptionsDisabled: true,
      LNQNKZDGptionsDisabled: true,
      hospitalEditProcessFalg: false,
      dialogVisiblesdrjg: false,
      tableDatadrjg: false,
      title: '',
      RowFlag: false,
      DetailRemarkdisabled: true,
      EditTitle: '编辑', //控制编辑按钮的Title
      EditFalg: true,//控制是否进入编辑模式 true: 没在编辑状态; false: 反之
      tableDataHistory: [
        {
          aa: "2022年2月_上海第九人民医院_医疗器械销售报表",
          bb: "2022-03-02 08:29:06",
          cc: "变更历史"
        }
      ],
      InvClass: '',
      headerDataHistory: [],
      headerDataWorkReport: [],
      tableDataWorkReport: [],
      tableDatadrjgs: [],
      TimeDate: '',
      ID: null,
      total: 0,
      totalHistory: 0,
      pageindex: 1,
      pagesize: 0,
      pagesizeHistory: 10,
      pageindexHistory: 1,
    }
  },
  created() {
    this.hospitalProcessList()
  },
  mounted() {
    this.headerDataHistory = JSON.parse(JSON.stringify(headerDataHistory))
    // this.headerDataWorkReport = JSON.parse(JSON.stringify(headerData))
    this.TimeDate = utils.getDateTime()
  },
  activated() { },
  updated() { },
  methods: {
    //报表列表
    async hospitalProcessList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });

      let {
        code,
        data,
        message
      } = await HospitalProcessList({
        pageSize: this.pagesize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.InvClass = data.InvClass
        this.total = data.Count
        this.headerDataWorkReport = data.ColumnSettings
        this.tableDataWorkReport = data.data

      } else {
        this.$notify.error({
          title: '提示',
          message: message
        })
      }
      loading.close();
    },
    // 提交报表
    async hospitalEditProcess() {
      let WorkReportArr = []
      this.tableDataWorkReport.map((item, index) => {
        let obj = null
          if (this.InvClass == '101') {
          obj = {
            id: item.ID,
            updateContent: {
              [this.headerDataWorkReport.filter(item => item.prop == 'PTA高压球囊扩张导管')[0].prop]: item.PTA高压球囊扩张导管Options.selected == "" ? null : item.PTA高压球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == 'PTA球囊扩张导管')[0].prop]: item.PTA球囊扩张导管Options.selected == "" ? null : item.PTA球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '腔静脉滤器抓捕器')[0].prop]: item.腔静脉滤器抓捕器Options.selected == "" ? null : item.腔静脉滤器抓捕器Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '外周球囊扩张导管')[0].prop]: item.外周球囊扩张导管Options.selected == "" ? null : item.外周球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '药物洗脱PTA球囊扩张导管')[0].prop]: item.药物洗脱PTA球囊扩张导管Options.selected == "" ? null : item.药物洗脱PTA球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '抓捕器')[0].prop]: item.抓捕器Options.selected == "" ? null : item.抓捕器Options.selected,
              DetailRemark: item.DetailRemark
            }
          }
        }
       
        if (this.InvClass == '102') {
          obj = {
            id: item.ID,
            updateContent: {
               [this.headerDataWorkReport.filter(item => item.prop == '弹簧圈系统')[0].prop]: item.弹簧圈系统Options.selected == "" ? null : item.弹簧圈系统Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '颅内球囊扩张导管')[0].prop]: item.颅内球囊扩张导管Options.selected == "" ? null : item.颅内球囊扩张导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '颅内支撑导管')[0].prop]: item.颅内支撑导管Options.selected == "" ? null : item.颅内支撑导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '颅内支持导管')[0].prop]: item.颅内支持导管Options.selected == "" ? null : item.颅内支持导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '球囊导引导管')[0].prop]: item.球囊导引导管Options.selected == "" ? null : item.球囊导引导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '取栓支架')[0].prop]: item.取栓支架Options.selected == "" ? null : item.取栓支架Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '一次性使用微导管')[0].prop]: item.一次性使用微导管Options.selected == "" ? null : item.一次性使用微导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '远端通路导引导管')[0].prop]: item.远端通路导引导管Options.selected == "" ? null : item.远端通路导引导管Options.selected,
              DetailRemark: item.DetailRemark
            }
          }
        }
        WorkReportArr.push(obj)
      })
      let {
        code,
        data,
        message
      } = await HospitalEditProcess(
        WorkReportArr
      )
      if (code == 0) {
        this.$notify.success({
          title: '提示',
          message: `${message}并已退出编辑模式`
        })


        this.EditFalg = true
        this.hospitalEditProcessFalg = true
        this.DetailRemarkdisabled = true
        this.hospitalProcessList()
      } else {
        this.$notify.error({
          title: '提示',
          message: message
        })
      }
    },
    // 操作报表历史
    async hospitalGetProcessOperation(ID) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await HospitalGetProcessOperation({
        ID: ID,
        pageSize: this.pagesizeHistory,
        pageIndex: this.pageindexHistory
      })
      if (code == 0) {
        this.totalHistory = data.Count
        this.dialogVisiblesHistory = true
        this.tableDataHistory = data.data
      }
      loading.close();
    },
    // 下载报表
    async hospitalExportProcessList() {
      let resexprot = await HospitalExportProcessList({
        pageSize: this.pagesize,
        pageIndex: this.pageindex
      });
      if (resexprot) {
        //console.log(resexprot);
        if (resexprot.code == 999) {
          this.$message({
            type: "warning",
            message: resexprot.message,
          });
        }
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot, `入院进度${str}`, "xlsx")
      } else {
        // 返回json
        this.$message.warning("导出失败");
      }
    },
    // 上传报表
    async hospitalImportProcess(file) {
      if (file) {
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formData = new FormData()
        formData.append("file", file)
        let res = await HospitalImportProcess(formData)
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: res.message
          })

          loading.close();
        } else if (res.code == 101) {
          this.$message({
            type: 'warning',
            message: res.message
          })
          loading.close();
        } else {
          this.dialogVisiblesdrjg = true
          this.tableDatadrjgs = res.data
          this.title = "导入结果"
          this.$message({
            type: 'error',
            message: res.message
          })
          loading.close();
        }
        this.hospitalProcessList()
        loading.close();
      }
    },
    dialogOKdrjg() {
      this.dialogVisiblesdrjg = false
    },
    canceldrjg() {
      this.dialogVisiblesdrjg = false
    },
    // 上传报表
    UploadReport(file) {
      this.hospitalImportProcess(file)
    },
    // 历史提交
    SubmissionHistory() {
      this.hospitalGetProcessOperation(this.ID)
    },
    // 下载报表
    ReportDowload() {
      this.hospitalExportProcessList()
    },
    EditHistory() {
      this.EditFalg = !this.EditFalg
      if (this.EditFalg) {
        this.hospitalProcessList()
      }
      this.hospitalEditProcessFalg = false
    },
    SubmitReport() {
      if (!this.EditFalg) {
        this.hospitalEditProcess()
      } else {
        this.$notify.info({
          title: '提示',
          message: '您目前不处于编辑模式'
        })
      }
    },
    LookAll() {
      this.hospitalGetProcessOperation(null)
    },
    // 确定提交历史报表
    dialogOKHistory() {

      this.dialogVisiblesHistory = false
    },
    // 取消提交历史报表
    cancelHistory() {
      console.log(this.$refs.WorkRef);
      this.dialogVisiblesHistory = false
    },
    // 选中行
    onRowClickHistory(val) {
      console.log(val, 'History');
    },
    // 全屏
    operationHistory() {
      let newPage = this.$router.resolve({
        name: 'WorkReportTable',
        query: {
          MenuID: "22",
          NodeID: "10142"
        }
      })
      // console.log(newPage,'newPage');
      window.open(newPage.href, "_blank");
    },
    onRowClickWorkReport(val) {
      this.RowFlag = true
      this.ID = val.ID
      console.log(val, 'val');
    },
    handlePageIndexChange(pageindex) {
      this.pageindex = pageindex
      this.hospitalProcessList()
    },
    handleSizeChange(pagesize) {
      this.pageSize = PageSize
      this.hospitalProcessList()
    },
    handleHistoryPageIndexChange(pageindex) {
      this.pageindexHistory = pageindex
      this.hospitalGetProcessOperation()
    },
    handleSizeHistoryChange(pagesize) {
      this.pagesizeHistory = pagesize
      this.hospitalGetProcessOperation()
    },
  },
  computed: {},
  watch: {
    EditFalg: {
      handler(newVal, oldVal) {
        // 控制编辑与取消编辑
        if (newVal) {
          this.EditTitle = '编辑'
          this.PTAOptionsDisabled = true
          this.HPOptionsDisabled = true
          this.DCBOptionsDisabled = true
          this.GCOptionsDisabled = true
          this.DetailRemarkdisabled = true
          this.YCXOptionsDisabled = true
          this.QSZJOptionsDisabled = true
          this.THQOptionsDisabled = true
          this.PQDYGptionsDisabled = true
          this.YDTLDYGptionsDisabled = true
          this.LNZCDGptionsDisabled = true
          this.LNZZDGptionsDisabled = true
          this.LNQNKZDGptionsDisabled = true
          this.paginationFalg = false
          if (!this.hospitalEditProcessFalg) {
            this.$notify.info({
              title: '提示',
              message: '已取消编辑模式'
            })
          }
        } else {
          this.$notify.warning({
            title: '提示',
            message: '已进入编辑模式'
          })
          this.PTAOptionsDisabled = false
          this.HPOptionsDisabled = false
          this.DCBOptionsDisabled = false
          this.GCOptionsDisabled = false
          this.DetailRemarkdisabled = false
          this.YCXOptionsDisabled = false
          this.QSZJOptionsDisabled = false
          this.THQOptionsDisabled = false
          this.PQDYGptionsDisabled = false
          this.YDTLDYGptionsDisabled = false
          this.LNZCDGptionsDisabled = false
          this.LNZZDGptionsDisabled = false
          this.LNQNKZDGptionsDisabled = false
          this.paginationFalg = false
          this.EditTitle = '取消编辑'
        }
      }
    }
  },
}
</script>
<style scoped lang='less'>
.WorkReportBottom-Com {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .UploadReport-Com {
    display: inline-block;
    margin-left: -10px;
  }

  .NewDateTime-Com {
    display: inline-block;
    width: 255px;
    height: 32px;
    background: #fafbfc;
    border-radius: 2px;
    border: 1px solid #e6e8eb;
    margin-top: 10px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424e66;
    padding-left: 15px;

    span {
      color: #16181a;
    }
  }
  .SubmissionHistory-Com {
    display: inline-block;
    margin-left: 8px;
    margin-right: 2px;
  }
}
.Btns {
  margin-left: 850px;
}
</style>